import { CISApi } from '@/entities/srm/ci';
import { useMutation } from '@tanstack/react-query';
import { useSRMViewStore } from './view-store';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';

export const useDeleteCI = ({
  id,
  onSuccess,
}: {
  id: string;
  onSuccess: (ids: string[], cb?: (edgeIds: string[]) => void) => void;
}) => {
  const { setGraphData } = useSRMViewStore((state) => ({
    setGraphData: state.setGraphData,
  }));
  const { t } = useTranslation();
  return useMutation({
    mutationKey: ['delete-ci', id],
    mutationFn: () => CISApi.deleteCI(id).then((res) => res.data),
    onSuccess: (ids) => {
      notifications.show({
        color: 'green',
        message: t('action.successDeleteMsg'),
      });
      onSuccess(ids);
      setGraphData((p) => {
        const nodeSet = new Set(ids);
        return {
          ...p,
          nodes: p.nodes.filter((n) => !nodeSet.has(n.id)),
          links: p.links.filter(
            (e) => !nodeSet.has(e.src_ci_id) && !nodeSet.has(e.dst_ci_id),
          ),
        };
      });
    },
  });
};